// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Clean, modern world map styles --- */

/* Container for the map and sidebar */
.worldmap-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  /* Important: align top */
  justify-content: flex-start;
  gap: 20px;
  flex-wrap: wrap;
}
/* Sidebar for top countries */
.worldmap-sidebar {
  width: 150px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  /* Align to top-left */
}

/* Map wrapper */
.worldmap-wrapper {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.worldmap-wrapper svg {
  width: 100% !important;
  /* height: 500px !important; */
  display: block;
}

/* Country fill and border */
.react-svg-worldmap path {
  /* Remove fill-opacity and fill so colorFunction can work */
  /* fill-opacity: 1 !important; */
  /* fill: unset !important; */
  stroke: #b0b0b0 !important;
  stroke-width: 1;
  transition: fill 0.2s;
}

/* No-data countries: gray, no tooltip, no pointer events */
path.no-tooltip {
  /* Remove fill so colorFunction can work */
  /* fill: unset !important; */
  pointer-events: none !important;
  cursor: default !important;
}

/* Hide empty tooltips */
.worldmap-wrapper .worldmap-tooltip:empty {
  display: none !important;
}

/* Bar styles for sidebar */
.worldmap-bar-bg {
  width: 100%;
  height: 4px;
  background: #e5e7eb;
  border-radius: 3px;
  margin-top: 2px;
}
.worldmap-bar {
  height: 100%;
  background: #3b82f6;
  border-radius: 3px;
  transition: width 0.3s;
}

.no-tooltip {
  pointer-events: none;
  /* disables hover/click */
}`, "",{"version":3,"sources":["webpack://./src/app/modules/Dashboard/components/DestinationCountryReport/worldmap-fix.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,SAAS;EACT,eAAe;AACjB;AACA,8BAA8B;AAC9B;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,OAAO;EACP,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,2DAA2D;EAC3D,gCAAgC;EAChC,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;AACvB;;AAEA,2DAA2D;AAC3D;EACE,0CAA0C;EAC1C,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;AAC3B","sourcesContent":["/* --- Clean, modern world map styles --- */\n\n/* Container for the map and sidebar */\n.worldmap-row {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  /* Important: align top */\n  justify-content: flex-start;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n/* Sidebar for top countries */\n.worldmap-sidebar {\n  width: 150px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  /* Align to top-left */\n}\n\n/* Map wrapper */\n.worldmap-wrapper {\n  flex: 1;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n.worldmap-wrapper svg {\n  width: 100% !important;\n  /* height: 500px !important; */\n  display: block;\n}\n\n/* Country fill and border */\n.react-svg-worldmap path {\n  /* Remove fill-opacity and fill so colorFunction can work */\n  /* fill-opacity: 1 !important; */\n  /* fill: unset !important; */\n  stroke: #b0b0b0 !important;\n  stroke-width: 1;\n  transition: fill 0.2s;\n}\n\n/* No-data countries: gray, no tooltip, no pointer events */\npath.no-tooltip {\n  /* Remove fill so colorFunction can work */\n  /* fill: unset !important; */\n  pointer-events: none !important;\n  cursor: default !important;\n}\n\n/* Hide empty tooltips */\n.worldmap-wrapper .worldmap-tooltip:empty {\n  display: none !important;\n}\n\n/* Bar styles for sidebar */\n.worldmap-bar-bg {\n  width: 100%;\n  height: 4px;\n  background: #e5e7eb;\n  border-radius: 3px;\n  margin-top: 2px;\n}\n.worldmap-bar {\n  height: 100%;\n  background: #3b82f6;\n  border-radius: 3px;\n  transition: width 0.3s;\n}\n\n.no-tooltip {\n  pointer-events: none;\n  /* disables hover/click */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
